import { Component, EventEmitter, inject, Input, OnDestroy, Output, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonComponent } from '../../../components/button/button.component';
import { CustomInputComponent } from '../../../components/custom-input/custom-input.component';
import { LABEL_CONSTANT, PLACEHOLDER_CONSTANT } from '../../../constant/constant';
import { CognitoService } from '../../../core/auth/cognito.service';
import { HttpErrorService } from '../../../core/services/http-error.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { SIGN_IN_STATE } from '../organization-login.component';

export interface IForgotPasswordForm {
  userName: FormControl<string | null>;
}

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ReactiveFormsModule, CustomInputComponent, ButtonComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent implements OnDestroy {
  @Input() public userName: string | undefined;
  @Output() setSignInState: EventEmitter<string> = new EventEmitter<string>();
  @Output() setResetFlowUsername: EventEmitter<string> = new EventEmitter<string>();

  private _cognitoService = inject(CognitoService);
  private _httpErrorService = inject(HttpErrorService);
  private _validationService = inject(ValidationService);
  private _cdr = inject(ChangeDetectorRef);

  LABEL_CONSTANT = LABEL_CONSTANT;
  PLACEHOLDER_CONSTANT = PLACEHOLDER_CONSTANT;
  forgotPasswordForm: FormGroup<IForgotPasswordForm>;
  errorInSendCode = '';
  isSendCodeLoading = false

  constructor() {
    this.forgotPasswordForm = new FormGroup<IForgotPasswordForm>({
      userName: new FormControl(null, [Validators.required, ValidationService.emailValidator()]),
    });
  }

  ngOnInit(): void {
    if (this.userName) {
      this.forgotPasswordForm.controls.userName.setValue(this.userName);
    }
  }
  
  ngOnDestroy(): void {
    this._httpErrorService.httpError.set('');
  }

  public onSubmit(): void {
    if (this.forgotPasswordForm.valid) {
      this.forgotPassword();
    } else {
      // shows validation error if the username is not present
      this._validationService.validateAllFormFields(this.forgotPasswordForm);
    }
  }

  public switchToLoginFlow(): void {
    this.setSignInState.emit(SIGN_IN_STATE.SIGN_IN);
  }

  private forgotPassword(): void {
    this.isSendCodeLoading = true
    const username = this.forgotPasswordForm.getRawValue().userName as string;
    this._cognitoService
      .resetPassword(username)
      .then(() => {
        this.isSendCodeLoading = false
        this.setResetFlowUsername.emit(username);
        this.setSignInState.emit(SIGN_IN_STATE.RESET_PASSWORD);
        this._cdr.detectChanges();
      })
      .catch((error: Error) => {
        this.isSendCodeLoading = false
        this.errorInSendCode = error as unknown as string;
        this._cdr.detectChanges();
      });
  }

  valueChange(isBlurEvent: boolean): void{
    if(isBlurEvent){
      this.errorInSendCode = '';
    }
  }
}
